import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { browserTracingIntegration, WINDOW, startBrowserTracingPageLoadSpan, startBrowserTracingNavigationSpan } from '@sentry/browser';
import { SEMANTIC_ATTRIBUTE_SENTRY_OP, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE } from '@sentry/core';

// Many of the types below had to be mocked out to prevent typescript issues
// these types are required for correct functionality.

/**
 * A browser tracing integration that uses React Router v3 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */
function reactRouterV3BrowserTracingIntegration(options) {
  var integration = browserTracingIntegration(_objectSpread(_objectSpread({}, options), {}, {
    instrumentPageLoad: false,
    instrumentNavigation: false
  }));
  var history = options.history,
    routes = options.routes,
    match = options.match,
    _options$instrumentPa = options.instrumentPageLoad,
    instrumentPageLoad = _options$instrumentPa === void 0 ? true : _options$instrumentPa,
    _options$instrumentNa = options.instrumentNavigation,
    instrumentNavigation = _options$instrumentNa === void 0 ? true : _options$instrumentNa;
  return _objectSpread(_objectSpread({}, integration), {}, {
    afterAllSetup: function afterAllSetup(client) {
      integration.afterAllSetup(client);
      if (instrumentPageLoad && WINDOW && WINDOW.location) {
        normalizeTransactionName(routes, WINDOW.location, match, function (localName) {
          var _attributes;
          var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'url';
          startBrowserTracingPageLoadSpan(client, {
            name: localName,
            attributes: (_attributes = {}, _defineProperty(_attributes, SEMANTIC_ATTRIBUTE_SENTRY_OP, 'pageload'), _defineProperty(_attributes, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.pageload.react.reactrouter_v3'), _defineProperty(_attributes, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, source), _attributes)
          });
        });
      }
      if (instrumentNavigation && history.listen) {
        history.listen(function (location) {
          if (location.action === 'PUSH' || location.action === 'POP') {
            normalizeTransactionName(routes, location, match, function (localName) {
              var _attributes2;
              var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'url';
              startBrowserTracingNavigationSpan(client, {
                name: localName,
                attributes: (_attributes2 = {}, _defineProperty(_attributes2, SEMANTIC_ATTRIBUTE_SENTRY_OP, 'navigation'), _defineProperty(_attributes2, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.navigation.react.reactrouter_v3'), _defineProperty(_attributes2, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, source), _attributes2)
              });
            });
          }
        });
      }
    }
  });
}

/**
 * Normalize transaction names using `Router.match`
 */
function normalizeTransactionName(appRoutes, location, match, callback) {
  var name = location.pathname;
  match({
    location: location,
    routes: appRoutes
  }, function (error, _redirectLocation, renderProps) {
    if (error || !renderProps) {
      return callback(name);
    }
    var routePath = getRouteStringFromRoutes(renderProps.routes || []);
    if (routePath.length === 0 || routePath === '/*') {
      return callback(name);
    }
    name = routePath;
    return callback(name, 'route');
  });
}

/**
 * Generate route name from array of routes
 */
function getRouteStringFromRoutes(routes) {
  if (!Array.isArray(routes) || routes.length === 0) {
    return '';
  }
  var routesWithPaths = routes.filter(function (route) {
    return !!route.path;
  });
  var index = -1;
  for (var x = routesWithPaths.length - 1; x >= 0; x--) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var route = routesWithPaths[x];
    if (route.path && route.path.startsWith('/')) {
      index = x;
      break;
    }
  }
  return routesWithPaths.slice(index).filter(function (_ref) {
    var path = _ref.path;
    return !!path;
  }).map(function (_ref2) {
    var path = _ref2.path;
    return path;
  }).join('');
}
export { reactRouterV3BrowserTracingIntegration };